import { ContentTaskPriority, CallPriority } from '../..';
export var ScenarioActionType;
(function (ScenarioActionType) {
    ScenarioActionType[ScenarioActionType["SEND_NOTIFICATION"] = 10] = "SEND_NOTIFICATION";
    ScenarioActionType[ScenarioActionType["CREATE_ARTICLE_TASK"] = 20] = "CREATE_ARTICLE_TASK";
    ScenarioActionType[ScenarioActionType["SEND_CHAT_AUTO_REPLY"] = 30] = "SEND_CHAT_AUTO_REPLY";
    ScenarioActionType[ScenarioActionType["END_ALL_HANDLING"] = 40] = "END_ALL_HANDLING";
    ScenarioActionType[ScenarioActionType["END_HANDLING"] = 41] = "END_HANDLING";
    ScenarioActionType[ScenarioActionType["END_CHAT"] = 45] = "END_CHAT";
    ScenarioActionType[ScenarioActionType["CHANGE_TICKET_STATUS"] = 50] = "CHANGE_TICKET_STATUS";
    ScenarioActionType[ScenarioActionType["ADD_INTERNAL_NOTE"] = 60] = "ADD_INTERNAL_NOTE";
    ScenarioActionType[ScenarioActionType["REASSIGN_TICKET"] = 70] = "REASSIGN_TICKET";
    ScenarioActionType[ScenarioActionType["SET_TICKET_LABELS"] = 80] = "SET_TICKET_LABELS";
    ScenarioActionType[ScenarioActionType["ADD_AGENT_REPLY"] = 90] = "ADD_AGENT_REPLY";
    ScenarioActionType[ScenarioActionType["UNASSIGN_TICKET"] = 100] = "UNASSIGN_TICKET";
    ScenarioActionType[ScenarioActionType["SET_TICKET_PRIORITY"] = 110] = "SET_TICKET_PRIORITY";
    ScenarioActionType[ScenarioActionType["CREATE_CALLBACK"] = 160] = "CREATE_CALLBACK";
    ScenarioActionType[ScenarioActionType["DELETE_CALL_RECORDING"] = 170] = "DELETE_CALL_RECORDING";
    ScenarioActionType[ScenarioActionType["SET_TICKET_BOOLEAN_CUSTOM_FIELD"] = 120] = "SET_TICKET_BOOLEAN_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_TICKET_NUMBER_CUSTOM_FIELD"] = 130] = "SET_TICKET_NUMBER_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_TICKET_SINGLE_SELECT_CUSTOM_FIELD"] = 140] = "SET_TICKET_SINGLE_SELECT_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_TICKET_TEXT_CUSTOM_FIELD"] = 150] = "SET_TICKET_TEXT_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_COMPANY_BOOLEAN_CUSTOM_FIELD"] = 180] = "SET_COMPANY_BOOLEAN_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_COMPANY_NUMBER_CUSTOM_FIELD"] = 190] = "SET_COMPANY_NUMBER_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_COMPANY_SINGLE_SELECT_CUSTOM_FIELD"] = 200] = "SET_COMPANY_SINGLE_SELECT_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_COMPANY_TEXT_CUSTOM_FIELD"] = 210] = "SET_COMPANY_TEXT_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_COMPANY_MULTI_SELECT_CUSTOM_FIELD"] = 220] = "SET_COMPANY_MULTI_SELECT_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_USER_BOOLEAN_CUSTOM_FIELD"] = 230] = "SET_USER_BOOLEAN_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_USER_NUMBER_CUSTOM_FIELD"] = 240] = "SET_USER_NUMBER_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_USER_SINGLE_SELECT_CUSTOM_FIELD"] = 250] = "SET_USER_SINGLE_SELECT_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_USER_TEXT_CUSTOM_FIELD"] = 260] = "SET_USER_TEXT_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_USER_MULTI_SELECT_CUSTOM_FIELD"] = 270] = "SET_USER_MULTI_SELECT_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_AGENT_BOOLEAN_CUSTOM_FIELD"] = 280] = "SET_AGENT_BOOLEAN_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_AGENT_NUMBER_CUSTOM_FIELD"] = 290] = "SET_AGENT_NUMBER_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_AGENT_SINGLE_SELECT_CUSTOM_FIELD"] = 300] = "SET_AGENT_SINGLE_SELECT_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_AGENT_TEXT_CUSTOM_FIELD"] = 310] = "SET_AGENT_TEXT_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_AGENT_MULTI_SELECT_CUSTOM_FIELD"] = 320] = "SET_AGENT_MULTI_SELECT_CUSTOM_FIELD";
    ScenarioActionType[ScenarioActionType["SET_AGENT_STATUS"] = 350] = "SET_AGENT_STATUS";
    ScenarioActionType[ScenarioActionType["SET_PRIORITY_SCORE"] = 400] = "SET_PRIORITY_SCORE";
    ScenarioActionType[ScenarioActionType["CHANGE_PRIORITY_SCORE"] = 410] = "CHANGE_PRIORITY_SCORE";
})(ScenarioActionType || (ScenarioActionType = {}));
export var NotificationTypeAction;
(function (NotificationTypeAction) {
    NotificationTypeAction[NotificationTypeAction["EMAIL"] = 10] = "EMAIL";
    NotificationTypeAction[NotificationTypeAction["IN_APP_NOTIFICATION"] = 20] = "IN_APP_NOTIFICATION";
    NotificationTypeAction[NotificationTypeAction["SLACK"] = 40] = "SLACK";
})(NotificationTypeAction || (NotificationTypeAction = {}));
export var TicketLabelsActionType;
(function (TicketLabelsActionType) {
    TicketLabelsActionType[TicketLabelsActionType["ADD"] = 1] = "ADD";
    TicketLabelsActionType[TicketLabelsActionType["REMOVE"] = 2] = "REMOVE";
    TicketLabelsActionType[TicketLabelsActionType["REPLACE"] = 3] = "REPLACE";
})(TicketLabelsActionType || (TicketLabelsActionType = {}));
;
export var ChangePriorityScoreOperator;
(function (ChangePriorityScoreOperator) {
    ChangePriorityScoreOperator[ChangePriorityScoreOperator["INCREASE"] = 1] = "INCREASE";
    ChangePriorityScoreOperator[ChangePriorityScoreOperator["DECREASE"] = 2] = "DECREASE";
})(ChangePriorityScoreOperator || (ChangePriorityScoreOperator = {}));
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
export var spotterEmptyActionMap = function (actionType) {
    var _a;
    var map = (_a = {},
        _a[ScenarioActionType.SEND_NOTIFICATION] = {
            actionType: ScenarioActionType.SEND_NOTIFICATION,
            disabled: true,
            message: '',
            notificationRecipients: {
                emails: [],
                groupIds: [],
                userIds: [],
            },
            toArticleAuthor: false,
            toArticleAuthorManager: false,
            toCallCenterQueueAssignees: false,
            toCallParticipants: false,
            toCallParticipantsManagers: false,
            toRelevantAgent: false,
            toRelevantAgentManager: false,
            toTicketAssignedAgentOrGroup: false,
            toTicketAssignedAgentManager: false,
            toChatParticipants: false,
            toChatParticipantsManagers: false,
            toCompanyAccountManager: false,
            toLastAgentReplier: false,
            toTicketAgents: false
        },
        _a[ScenarioActionType.SEND_CHAT_AUTO_REPLY] = {
            actionType: ScenarioActionType.SEND_CHAT_AUTO_REPLY,
            disabled: true,
            messageContent: '',
        },
        _a[ScenarioActionType.CREATE_ARTICLE_TASK] = {
            actionType: ScenarioActionType.CREATE_ARTICLE_TASK,
            disabled: true,
            contentTaskPriority: ContentTaskPriority.MEDIUM,
        },
        _a[ScenarioActionType.END_ALL_HANDLING] = {
            actionType: ScenarioActionType.END_ALL_HANDLING,
            disabled: false,
        },
        _a[ScenarioActionType.END_HANDLING] = {
            actionType: ScenarioActionType.END_HANDLING,
            disabled: false,
        },
        _a[ScenarioActionType.CHANGE_TICKET_STATUS] = {
            actionType: ScenarioActionType.CHANGE_TICKET_STATUS,
            disabled: true,
        },
        _a[ScenarioActionType.ADD_INTERNAL_NOTE] = {
            actionType: ScenarioActionType.ADD_INTERNAL_NOTE,
            disabled: true,
            noteContent: '',
        },
        _a[ScenarioActionType.REASSIGN_TICKET] = {
            actionType: ScenarioActionType.REASSIGN_TICKET,
            disabled: true,
        },
        _a[ScenarioActionType.SET_TICKET_LABELS] = {
            actionType: ScenarioActionType.SET_TICKET_LABELS,
            disabled: true,
            labelIds: [],
            labelsActionType: TicketLabelsActionType.ADD,
        },
        _a[ScenarioActionType.ADD_AGENT_REPLY] = {
            actionType: ScenarioActionType.ADD_AGENT_REPLY,
            disabled: true,
            replyContent: ''
        },
        _a[ScenarioActionType.UNASSIGN_TICKET] = {
            actionType: ScenarioActionType.UNASSIGN_TICKET,
            disabled: false,
        },
        _a[ScenarioActionType.SET_TICKET_PRIORITY] = {
            actionType: ScenarioActionType.SET_TICKET_PRIORITY,
            disabled: true,
        },
        _a[ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_TICKET_NUMBER_CUSTOM_FIELD,
            disabled: true,
            numberValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_AGENT_NUMBER_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_AGENT_NUMBER_CUSTOM_FIELD,
            disabled: true,
            numberValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_COMPANY_NUMBER_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_COMPANY_NUMBER_CUSTOM_FIELD,
            disabled: true,
            numberValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_USER_NUMBER_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_USER_NUMBER_CUSTOM_FIELD,
            disabled: true,
            numberValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_TICKET_BOOLEAN_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_TICKET_BOOLEAN_CUSTOM_FIELD,
            disabled: true,
            boolValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_AGENT_BOOLEAN_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_AGENT_BOOLEAN_CUSTOM_FIELD,
            disabled: true,
            boolValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_COMPANY_BOOLEAN_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_COMPANY_BOOLEAN_CUSTOM_FIELD,
            disabled: true,
            boolValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_USER_BOOLEAN_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_USER_BOOLEAN_CUSTOM_FIELD,
            disabled: true,
            boolValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_TICKET_SINGLE_SELECT_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_TICKET_SINGLE_SELECT_CUSTOM_FIELD,
            disabled: true,
            singleSelectValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_AGENT_SINGLE_SELECT_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_AGENT_SINGLE_SELECT_CUSTOM_FIELD,
            disabled: true,
            singleSelectValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_COMPANY_SINGLE_SELECT_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_COMPANY_SINGLE_SELECT_CUSTOM_FIELD,
            disabled: true,
            singleSelectValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_USER_SINGLE_SELECT_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_USER_SINGLE_SELECT_CUSTOM_FIELD,
            disabled: true,
            singleSelectValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_TICKET_TEXT_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_TICKET_TEXT_CUSTOM_FIELD,
            disabled: true,
            textValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_AGENT_TEXT_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_AGENT_TEXT_CUSTOM_FIELD,
            disabled: true,
            textValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_COMPANY_TEXT_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_COMPANY_TEXT_CUSTOM_FIELD,
            disabled: true,
            textValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_USER_TEXT_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_USER_TEXT_CUSTOM_FIELD,
            disabled: true,
            textValue: null,
            clearValue: false
        },
        _a[ScenarioActionType.SET_AGENT_MULTI_SELECT_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_AGENT_MULTI_SELECT_CUSTOM_FIELD,
            disabled: true,
            multiSelectValues: [],
            clearValue: false
        },
        _a[ScenarioActionType.SET_COMPANY_MULTI_SELECT_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_COMPANY_MULTI_SELECT_CUSTOM_FIELD,
            disabled: true,
            multiSelectValues: [],
            clearValue: false
        },
        _a[ScenarioActionType.SET_USER_MULTI_SELECT_CUSTOM_FIELD] = {
            actionType: ScenarioActionType.SET_USER_MULTI_SELECT_CUSTOM_FIELD,
            disabled: true,
            multiSelectValues: [],
            clearValue: false
        },
        _a[ScenarioActionType.CREATE_CALLBACK] = {
            actionType: ScenarioActionType.CREATE_CALLBACK,
            disabled: true,
            callPriority: CallPriority.NORMAL,
        },
        _a[ScenarioActionType.END_CHAT] = {
            actionType: ScenarioActionType.END_CHAT,
            disabled: false,
        },
        _a[ScenarioActionType.DELETE_CALL_RECORDING] = {
            actionType: ScenarioActionType.DELETE_CALL_RECORDING,
            disabled: false,
        },
        _a[ScenarioActionType.SET_PRIORITY_SCORE] = {
            actionType: ScenarioActionType.SET_PRIORITY_SCORE,
            disabled: false,
            priority: null
        },
        _a[ScenarioActionType.CHANGE_PRIORITY_SCORE] = {
            actionType: ScenarioActionType.CHANGE_PRIORITY_SCORE,
            disabled: false,
            priority: null,
            increaseDecreaseOperator: ChangePriorityScoreOperator.INCREASE
        },
        _a[ScenarioActionType.SET_AGENT_STATUS] = {
            actionType: ScenarioActionType.SET_AGENT_STATUS,
            agentStatus: null,
            customStatusId: null,
            disabled: false,
        },
        _a);
    return map[actionType];
};
//# sourceMappingURL=actions.js.map